window.zbDrag=window.zbDrag||function(el){if(!el||el.dataset.zbd)return;el.dataset.zbd=1;let d=false,x0=0,s0=0,mv=false,snap='';el.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0)return;d=true;mv=false;x0=e.clientX;s0=el.scrollLeft;snap=getComputedStyle(el).scrollSnapType;});addEventListener('pointermove',e=>{if(!d)return;const dx=e.clientX-x0;if(!mv&&Math.abs(dx)>4){mv=true;el.style.scrollSnapType='none';el.style.scrollBehavior='auto';el.classList.add('zb-dragging');}if(mv){e.preventDefault();el.scrollLeft=s0-dx;}});addEventListener('pointerup',()=>{if(!d)return;d=false;el.classList.remove('zb-dragging');if(mv){el.style.scrollSnapType='';el.style.scrollBehavior='';const l=el.scrollLeft;el.scrollLeft=l;}setTimeout(()=>{mv=false},0);});el.addEventListener('click',e=>{if(mv){e.preventDefault();e.stopPropagation();}},true);el.addEventListener('dragstart',e=>e.preventDefault());el.querySelectorAll('img').forEach(i=>i.setAttribute('draggable','false'));};
/* ZenBud "Quiet Signal" prototype — motion layer.
   Named tokens below match DIRECTION.md (motion system). */
(() => {
  const RM = document.documentElement.classList.contains('rm');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const isMobile = () => matchMedia('(max-width: 860px)').matches;

  const T = {
    ease: { out: 'expo.out', inout: 'power4.inOut', std: 'power2.out', mask: 'power4.inOut', settle: 'power3.out' },
    dur: { micro: .15, ui: .3, reveal: .9, cine: 1.6, slow: 2.4 },
    stagger: { lines: .09, items: .06, bars: .012 }
  };
  // custom curves equivalent to CSS tokens
  if (window.CustomEase) { /* not loaded in prototype; GSAP built-ins approximate tokens */ }

  /* ---------------- builders (run regardless of motion pref) ---------------- */
  const NBARS = isMobile() ? 28 : 44;
  const barsEl = $('#bars');
  const bars = [];
  // illustrative profiles: elevated baseline -> settled
  const rnd = (a, b) => a + Math.random() * (b - a);
  for (let i = 0; i < NBARS; i++) {
    const d = document.createElement('div'); d.className = 'bar future';
    const inner = document.createElement('i'); d.appendChild(inner);
    barsEl.appendChild(d);
    const t = i / (NBARS - 1);
    const hi = Math.min(.96, .74 + .16 * Math.sin(i * 1.7) * .5 + rnd(-.06, .12));
    const lo = Math.max(.12, .62 - .44 * Math.pow(t, .7) + rnd(-.05, .05));
    bars.push({ el: d, inner, hi, lo, h: .02, base: .02, phase: rnd(0, Math.PI * 2), speed: rnd(.6, 1.3) });
  }

  // ring ticks
  const ticksG = $('#ringTicks');
  const NT = 60;
  for (let i = 0; i < NT; i++) {
    const a = (i / NT) * Math.PI * 2;
    const r1 = 90, r2 = 96;
    const l = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    l.setAttribute('x1', 100 + r1 * Math.cos(a)); l.setAttribute('y1', 100 + r1 * Math.sin(a));
    l.setAttribute('x2', 100 + r2 * Math.cos(a)); l.setAttribute('y2', 100 + r2 * Math.sin(a));
    ticksG.appendChild(l);
  }
  const ticks = $$('line', ticksG);

  // HRV path (14 days rising, illustrative)
  const hrvPts = [];
  const hrvVals = [41, 43, 40, 44, 46, 45, 48, 47, 51, 50, 53, 55, 54, 58];
  hrvVals.forEach((v, i) => hrvPts.push([i * (400 / 13), 150 - ((v - 34) / 28) * 130]));
  const smooth = (pts) => {
    let d = `M${pts[0][0]},${pts[0][1]}`;
    for (let i = 0; i < pts.length - 1; i++) {
      const p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
      const c1 = [p1[0] + (p2[0] - p0[0]) / 6, p1[1] + (p2[1] - p0[1]) / 6];
      const c2 = [p2[0] - (p3[0] - p1[0]) / 6, p2[1] - (p3[1] - p1[1]) / 6];
      d += ` C${c1[0].toFixed(1)},${c1[1].toFixed(1)} ${c2[0].toFixed(1)},${c2[1].toFixed(1)} ${p2[0].toFixed(1)},${p2[1].toFixed(1)}`;
    }
    return d;
  };
  const hrvD = smooth(hrvPts);
  $('#hrvPath').setAttribute('d', hrvD);
  $('#hrvArea').setAttribute('d', hrvD + ' L400,150 L0,150 Z');
  // end dot lives in the second (non-stretched) svg so it stays round
  const dotSvg = $('#hrvSvg').nextElementSibling;
  dotSvg.setAttribute('preserveAspectRatio', 'none');
  const last = hrvPts[hrvPts.length - 1];
  const mkC = (cls, r) => { const c = document.createElementNS('http://www.w3.org/2000/svg', 'ellipse'); c.setAttribute('class', cls); c.setAttribute('cx', last[0]); c.setAttribute('cy', last[1]); c.setAttribute('rx', r); c.setAttribute('ry', r); dotSvg.appendChild(c); return c; };
  const halo = mkC('hrv-halo', 9), dot = mkC('hrv-dot', 3.5);
  const fixDot = () => { // compensate non-uniform scaling
    const r = dotSvg.getBoundingClientRect(); if (!r.width) return;
    const sx = 400 / r.width, sy = 150 / r.height;
    [[dot, 3.5], [halo, 9]].forEach(([c, rr]) => { c.setAttribute('rx', rr * sx); c.setAttribute('ry', rr * sy); });
  };
  fixDot(); addEventListener('resize', fixDot);

  // mini RHR bars (7 days)
  const mini = $('#mini');
  const rhrDays = [.92, .86, .9, .8, .74, .7, .64];
  rhrDays.forEach((v, i) => { const x = document.createElement('i'); if (i === 6) x.className = 'now'; mini.appendChild(x); });
  const minis = $$('i', mini);

  // how-it-works grid + waves
  const hg = $('#howGrid');
  for (let i = 1; i < 12; i++) {
    const a = document.createElementNS('http://www.w3.org/2000/svg', 'line'); a.setAttribute('x1', i * 50); a.setAttribute('x2', i * 50); a.setAttribute('y1', 0); a.setAttribute('y2', 600); hg.appendChild(a);
    const b = document.createElementNS('http://www.w3.org/2000/svg', 'line'); b.setAttribute('y1', i * 50); b.setAttribute('y2', i * 50); b.setAttribute('x1', 0); b.setAttribute('x2', 600); hg.appendChild(b);
  }
  const wavesG = $('#waves');
  const waves = [0, 1, 2].map(() => { const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle'); c.setAttribute('class', 'wave'); c.setAttribute('cx', 226); c.setAttribute('cy', 148); c.setAttribute('r', 10); c.style.opacity = 0; wavesG.appendChild(c); return c; });

  // statement words
  const st = $('#statement');
  const hl = ['ZenBud', 'five', 'quiet', 'minutes', 'shift', 'down.'];
  st.innerHTML = st.textContent.trim().split(/\s+/).map(w => `<span class="w${hl.includes(w) ? ' hl' : ''}">${w}</span>`).join(' ');

  /* ---------------- reduced motion: final states, no smooth scroll ---------------- */
  const pad = (n, l = 2) => String(Math.floor(n)).padStart(l, '0');
  const setFinal = () => {
    bars.forEach((b, i) => { b.el.classList.remove('future'); b.el.classList.add('calm'); if (i >= NBARS - 3) b.el.classList.add('now'); b.inner.style.transform = `scaleY(${b.lo})`; });
    $('#stressVal').textContent = 31; $('#timer').textContent = '15:00'; $('#phaseLabel').textContent = 'Settled';
    $$('#phaseRail b').forEach(b => b.style.transform = 'scaleX(1)');
    $('#ringArc').style.strokeDashoffset = 465 * (1 - .72); $('#ringVal').textContent = 72;
    ticks.forEach((t, i) => i < NT * .72 && t.classList.add('on'));
    $('#kvSessions').textContent = 24; $('#kvStreak').textContent = '12 days'; $('#kvTime').textContent = '360 min';
    $('#hrvVal').textContent = 58; $('#hrvDelta').textContent = '+41%'; $('#rhrVal').textContent = 62;
    minis.forEach((m, i) => m.style.transform = `scaleY(${rhrDays[i]})`);
    $('#statVal').textContent = '78.6'; $('#meter').style.transform = 'scaleX(1)';
    $('#gRing').style.strokeDashoffset = 0;
    $$('.node').forEach(n => n.classList.add('on'));
    $$('.organ,.glow').forEach(n => n.classList.add('on'));
  };
  if (RM || !window.gsap) { setFinal(); return; }

  gsap.registerPlugin(ScrollTrigger);

  /* ---------------- smooth scroll (Lenis) ---------------- */
  const lenis = new Lenis({ duration: 1.15, easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
  window.lenis = lenis;
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add(t => lenis.raf(t * 1000));
  gsap.ticker.lagSmoothing(0);
  $$('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
    const id = a.getAttribute('href'); if (id.length < 2) return; e.preventDefault(); lenis.scrollTo(id, { offset: -10, duration: 1.6 });
  }));

  /* ---------------- nav ---------------- */
  ScrollTrigger.create({ start: 40, onUpdate: s => $('#nav').classList.toggle('is-scrolled', s.scroll() > 40) });

  /* ---------------- hero: load choreography ---------------- */
  const heroTl = gsap.timeline({ defaults: { ease: T.ease.out } });
  heroTl
    .from('#heroVideo', { scale: 1.14, duration: T.dur.slow })
    .from('.hero__shade', { opacity: 0, duration: T.dur.cine }, 0)
    .from('.hero h1 .ln > span', { yPercent: 110, duration: 1.4, stagger: T.stagger.lines }, .25)
    .from('[data-hero="eyebrow"]', { opacity: 0, y: 14, duration: T.dur.reveal }, .2)
    .from('[data-hero="sub"] > *', { opacity: 0, y: 24, filter: 'blur(6px)', duration: 1.1, stagger: .08 }, .7)
    .from('[data-hero="meta"] > div', { opacity: 0, y: 18, duration: 1, stagger: .08 }, .9)
    .from('.nav__in > *', { opacity: 0, y: -10, duration: 1, stagger: .06 }, .4)
    .from('.hero__rail', { scaleX: 0, transformOrigin: '0 50%', duration: T.dur.slow, ease: T.ease.inout }, .3);

  // hero scroll: frame insets into a rounded card, copy lifts away
  gsap.timeline({ scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true } })
    .fromTo('#heroMedia', { clipPath: 'inset(0% 0% 0% 0% round 0px)' }, { clipPath: 'inset(7% 3.5% 7% 3.5% round 28px)', ease: 'none' }, 0)
    .to('#heroVideo', { scale: 1.08, yPercent: 6, ease: 'none' }, 0)
    .to('.hero__content', { yPercent: -30, opacity: 0, ease: 'none' }, 0);

  /* ---------------- generic reveals ---------------- */
  ScrollTrigger.batch('[data-reveal]', {
    start: 'top 88%', once: true,
    onEnter: els => gsap.to(els, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 1.1, ease: T.ease.out, stagger: T.stagger.items, overwrite: true })
  });

  /* ---------------- statement: word-by-word scrub ---------------- */
  gsap.to('#statement .w', {
    opacity: 1, stagger: .1, ease: 'none',
    scrollTrigger: { trigger: '#statement', start: 'top 80%', end: 'bottom 45%', scrub: .6 }
  });

  /* ---------------- LIVE data dashboard ---------------- */
  const S = { stress: 0, time: 0, ring: 0, hrv: 0, rhr: 0, sessions: 0, streak: 0, mins: 0, settled: false };
  const pathLen = $('#hrvPath').getTotalLength();
  gsap.set('#hrvPath', { strokeDasharray: pathLen, strokeDashoffset: pathLen });
  gsap.set('#hrvArea', { opacity: 0 });
  gsap.set([dot, halo], { opacity: 0 });
  const renderNums = () => {
    $('#stressVal').textContent = Math.round(S.stress);
    $('#timer').textContent = `${pad(S.time / 60)}:${pad(S.time % 60)}`;
    $('#ringVal').textContent = Math.round(S.ring * 100);
    $('#ringArc').style.strokeDashoffset = 465 * (1 - S.ring);
    const on = Math.round(S.ring * NT); ticks.forEach((t, i) => t.classList.toggle('on', i < on));
    $('#hrvVal').textContent = Math.round(S.hrv);
    $('#hrvDelta').textContent = `+${Math.max(0, Math.round((S.hrv / 41 - 1) * 100))}%`;
    $('#rhrVal').textContent = Math.round(S.rhr);
    $('#kvSessions').textContent = Math.round(S.sessions);
    $('#kvStreak').textContent = `${Math.round(S.streak)} days`;
    $('#kvTime').textContent = `${Math.round(S.mins)} min`;
  };
  const phases = ['Baseline', 'Engaging', 'Downshift', 'Settling', 'Settled'];
  const scan = $('#scan');
  let dashTl;
  const buildDash = () => {
    if (dashTl) dashTl.kill();
    Object.assign(S, { stress: 0, time: 0, ring: 0, hrv: 0, rhr: 0, sessions: 0, streak: 0, mins: 0, settled: false });
    bars.forEach(b => { b.h = .02; b.base = .02; b.el.className = 'bar future'; });
    gsap.set('#phaseRail b', { scaleX: 0 });
    gsap.set('#hrvPath', { strokeDashoffset: pathLen }); gsap.set('#hrvArea', { opacity: 0 }); gsap.set([dot, halo], { opacity: 0 });
    gsap.set(minis, { scaleY: .05 });
    gsap.set(scan, { left: 0, opacity: 0 });
    $('#phaseLabel').textContent = phases[0];
    const SESSION = 5.2; // compressed 15:00 → 5.2s
    const tl = gsap.timeline({ onUpdate: renderNums });
    // 1. bars rise to elevated baseline, stagger from center
    tl.to(bars, { h: i => bars[i].hi, base: i => bars[i].hi, duration: 1.3, ease: T.ease.out, stagger: { each: T.stagger.bars, from: 'center' } }, 0)
      .to(S, { stress: 82, duration: 1.3, ease: T.ease.out }, 0)
      .to(S, { rhr: 71, hrv: 41, sessions: 24, streak: 12, mins: 360, duration: 1.4, ease: T.ease.out }, .1)
      .to(minis, { scaleY: i => rhrDays[i] + .08, duration: 1, ease: T.ease.out, stagger: .05 }, .2)
      .to(S, { ring: .18, duration: 1.2, ease: T.ease.out }, .2)
      .to(scan, { opacity: 1, duration: .4 }, 1.2);
    // 2. session sweep: scan moves L→R, bars behind it ease down & turn calm
    const sweep = { p: 0 };
    tl.to(sweep, {
      p: 1, duration: SESSION, ease: 'none',
      onUpdate: () => {
        const p = sweep.p, W = barsEl.clientWidth;
        scan.style.left = `${p * W}px`;
        S.time = p * 900;
        const idx = Math.floor(p * NBARS);
        for (let i = 0; i < idx; i++) { const b = bars[i]; if (!b.done) { b.done = true; b.el.classList.remove('future'); b.el.classList.add('calm'); gsap.to(b, { h: b.lo, base: b.lo, duration: 1.4, ease: T.ease.settle }); } }
        bars.forEach((b, i) => b.el.classList.toggle('now', i >= idx - 3 && i < idx));
        const ph = Math.min(4, Math.floor(p * 5)); $('#phaseLabel').textContent = phases[ph];
        $$('#phaseRail b').forEach((b, i) => { b.style.transform = `scaleX(${Math.max(0, Math.min(1, p * 5 - i))})`; });
      },
      onStart: () => bars.forEach(b => b.done = false)
    }, 1.5)
      .to(S, { stress: 31, duration: SESSION, ease: 'power2.inOut' }, 1.5)
      .to(S, { ring: .72, duration: SESSION, ease: 'power2.inOut' }, 1.5)
      .to(S, { rhr: 62, duration: SESSION, ease: 'power2.inOut' }, 1.5)
      .to('#hrvPath', { strokeDashoffset: 0, duration: SESSION * .9, ease: 'power2.inOut' }, 1.6)
      .to(S, { hrv: 58, duration: SESSION * .9, ease: 'power2.inOut' }, 1.6)
      .to('#hrvArea', { opacity: 1, duration: 1.4, ease: T.ease.std }, 1.6 + SESSION * .5)
      .to(minis, { scaleY: i => rhrDays[i], duration: 1.2, ease: T.ease.settle, stagger: .04 }, 2.2)
      .to([dot, halo], { opacity: 1, duration: .6 }, 1.6 + SESSION * .9)
      .to(scan, { opacity: 0, duration: .6 }, 1.5 + SESSION)
      .add(() => { $('#phaseLabel').textContent = 'Settled'; S.settled = true; bars.forEach((b, i) => b.el.classList.toggle('now', i >= NBARS - 3)); bars.forEach(b => { if (!b.done) { b.el.classList.remove('future'); b.el.classList.add('calm'); gsap.to(b, { h: b.lo, base: b.lo, duration: 1.2, ease: T.ease.settle }); } }); }, 1.5 + SESSION);
    dashTl = tl;
    return tl;
  };
  ScrollTrigger.create({ trigger: '#dash', start: 'top 72%', once: true, onEnter: () => buildDash() });
  $('#replay').addEventListener('click', () => buildDash());

  // the "alive" loop: breathing + periodic re-targets after settle
  let t0 = performance.now();
  const chL = $('#chL'), chR = $('#chR'), clock = $('#clock');
  gsap.ticker.add(() => {
    const t = (performance.now() - t0) / 1000;
    for (const b of bars) {
      const amp = S.settled ? 0 : .035; /* jon-1103: hold still once settled */
      const breath = S.settled ? 1 : 1 + amp * Math.sin(t * b.speed * 1.4 + b.phase) + .025 * Math.sin(t * 3.1 + b.phase * 2);
      b.inner.style.transform = `scaleY(${Math.max(.02, Math.min(1, b.h * breath)).toFixed(4)})`;
    }
    if (S.settled) {
      // ring and HRV halo breathe too
      const ringLive = .72;
      $('#ringArc').style.strokeDashoffset = 465 * (1 - ringLive);
      const hs = 1;
      halo.style.opacity = .35;
      halo.style.transformOrigin = `${last[0]}px ${last[1]}px`;
      halo.style.transform = `scale(${hs})`;
    }
    if (S.settled) return; /* jon-1103: freeze readouts once settled */
    chL.textContent = (0.42 + .06 * Math.sin(t * 2.3) + .01 * Math.sin(t * 17)).toFixed(2);
    chR.textContent = (0.41 + .06 * Math.sin(t * 2.1 + 1) + .01 * Math.sin(t * 13)).toFixed(2);
    const s = t + 9 * 3600 + 41 * 60;
    clock.textContent = `${pad(s / 3600 % 24)}:${pad(s / 60 % 60)}:${pad(s % 60)}.${Math.floor((s % 1) * 10)}`;
  });
  // every ~1.8s, settled bars adjust to new nearby targets (feels live, like a strain/recovery feed)
  setInterval(() => {
    return; /* jon-1103: no live jitter after settle */
    if (!S.settled || document.hidden) return;
    bars.forEach(b => { if (Math.random() < .45) gsap.to(b, { h: Math.max(.08, b.base * rnd(.84, 1.16)), duration: rnd(.9, 1.6), ease: 'sine.inOut' }); });
    const s = 31 + Math.round(rnd(-2, 2)); gsap.to(S, { stress: s, duration: 1.2, ease: 'sine.inOut', onUpdate: () => $('#stressVal').textContent = Math.round(S.stress) });
  }, 1800);

  /* ---------------- HOW: pinned storytelling ---------------- */
  const steps = $$('.step'), nodes = $$('.node');
  const sig = $('#sigPath'), sigLen = sig.getTotalLength();
  gsap.set(sig, { strokeDasharray: sigLen, strokeDashoffset: sigLen });
  // node positions along path (fractions)
  // fractions along the path where each node sits (measured, so the path can be redrawn freely)
  const nodeAt = nodes.map(nd => {
    const m = /translate\(([\d.]+) ([\d.]+)\)/.exec(nd.getAttribute('transform'));
    const x = +m[1], y = +m[2]; let best = 0, bd = 1e9;
    for (let l = 0; l <= sigLen; l += 2) { const q = sig.getPointAtLength(l); const d = (q.x - x) ** 2 + (q.y - y) ** 2; if (d < bd) { bd = d; best = l; } }
    return best / sigLen;
  });
  // organs light as the pulse passes them
  const organs = [['#orgLungs', '#glowHeart', 335], ['#orgHeart', '#glowHeart', 368], ['#orgGut', '#glowGut', 470]].map(([o, g, y]) => ({ o: $(o), g: $(g), y }));
  const fig = $$('#figure > *');
  fig.forEach(f => { const L = f.getTotalLength(); f.style.strokeDasharray = L; f.style.strokeDashoffset = L; });
  ScrollTrigger.create({ trigger: '#how', start: 'top 75%', once: true, onEnter: () => gsap.to(fig, { strokeDashoffset: 0, duration: 2.4, ease: T.ease.inout, stagger: .08 }) });
  let cur = -1;
  const setStep = (n) => {
    if (n === cur) return; cur = n;
    steps.forEach((s, i) => {
      gsap.to(s, { opacity: i === n ? 1 : 0, y: i === n ? 0 : (i < n ? -30 : 30), filter: i === n ? 'blur(0px)' : 'blur(8px)', duration: .8, ease: T.ease.out, overwrite: true });
    });
    nodes.forEach((nd, i) => { nd.classList.toggle('on', i <= n); nd.classList.toggle('cur', i === n); });
    $('#howNum').textContent = pad(n + 1);
    nodes.forEach((nd, i) => { const h = $('.halo', nd); gsap.killTweensOf(h); if (i === n) gsap.fromTo(h, { opacity: .9, scale: .5, transformOrigin: 'center' }, { opacity: 0, scale: 1.6, duration: 1.8, ease: 'sine.out', repeat: -1 }); else gsap.set(h, { opacity: 0 }); });
  };
  steps.forEach((s, i) => i && gsap.set(s, { opacity: 0, y: 30 }));
  setStep(0);
  ScrollTrigger.create({
    trigger: '#how', start: 'top top', end: () => `+=${innerHeight * 1.6}`, pin: '#howPin', scrub: true, anticipatePin: 1,
    onUpdate: self => {
      const p = self.progress;
      const drawn = Math.min(1, p * 1.08);
      sig.style.strokeDashoffset = sigLen * (1 - drawn);
      const pt = sig.getPointAtLength(sigLen * drawn);
      $('#pulse').setAttribute('cx', pt.x); $('#pulse').setAttribute('cy', pt.y);
      let n = 0; nodeAt.forEach((f, i) => { if (drawn >= f - .02) n = i; });
      setStep(n);
      organs.forEach(o => { const on = pt.y >= o.y - 4; o.o.classList.toggle('on', on); o.g.classList.toggle('on', on); });
      $$('#howRail b').forEach((b, i) => b.style.transform = `scaleX(${Math.max(0, Math.min(1, p * 4 - i))})`);
    }
  });
  // ultrasound ripples at the ear: ambient
  waves.forEach((w, i) => gsap.fromTo(w, { attr: { r: 12 }, opacity: .7 }, { attr: { r: 70 }, opacity: 0, duration: 3, ease: 'sine.out', repeat: -1, delay: i * 1 }));

  /* ---------------- PRODUCT: luxury mask reveals ---------------- */
  gsap.timeline({ scrollTrigger: { trigger: '#heroShot', start: 'top 85%', end: 'top 15%', scrub: 1 } })
    .fromTo('#heroShot', { clipPath: 'inset(18% 12% 18% 12% round 28px)' }, { clipPath: 'inset(0% 0% 0% 0% round 28px)', ease: 'none' }, 0)
    .fromTo('#heroShot img', { scale: 1.3 }, { scale: 1, ease: 'none' }, 0);
  ScrollTrigger.create({ trigger: '#heroShot', start: 'top 35%', once: true, onEnter: () => gsap.to('#heroShot .shot-tag', { opacity: 1, y: 0, duration: 1, stagger: .15, ease: T.ease.out }) });
  gsap.set('#heroShot .shot-tag', { y: 10 });

  $$('[data-wipe]').forEach((el, i) => {
    const media = el.querySelector('img,video');
    gsap.fromTo(el, { clipPath: 'inset(0% 0% 100% 0% round 18px)' }, {
      clipPath: 'inset(0% 0% 0% 0% round 18px)', duration: 1.5, ease: T.ease.mask, delay: (i % 3) * .12,
      scrollTrigger: { trigger: el, start: 'top 88%', once: true }
    });
    gsap.fromTo(media, { scale: 1.25 }, { scale: 1, duration: 2.4, ease: T.ease.out, delay: (i % 3) * .12, scrollTrigger: { trigger: el, start: 'top 88%', once: true } });
    gsap.fromTo(media, { yPercent: -4 }, { yPercent: 4, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
  });

  // count-ups (generic)
  $$('[data-count]').forEach(el => {
    const to = +el.dataset.count; const o = { v: 0 };
    ScrollTrigger.create({ trigger: el, start: 'top 90%', once: true, onEnter: () => gsap.to(o, { v: to, duration: 1.4, ease: T.ease.out, onUpdate: () => el.textContent = Math.round(o.v) }) });
  });

  /* ---------------- BOX: exploded kit assembles on scroll ---------------- */
  const kitEls = $$('#kit .k');
  const kitFrom = [{ x: 60, y: 40, r: -4 }, { x: -80, y: 60, r: 6 }, { x: -60, y: -40, r: -8 }, { x: 70, y: -70, r: 5 }, { x: -40, y: -60, r: -3 }];
  kitEls.forEach((k, i) => {
    gsap.fromTo(k, { x: kitFrom[i].x * (isMobile() ? .4 : 1), y: kitFrom[i].y, rotate: kitFrom[i].r, scale: .82, opacity: 0, clipPath: 'inset(10% 10% 10% 10% round 18px)' },
      { x: 0, y: 0, rotate: 0, scale: 1, opacity: 1, clipPath: 'inset(0% 0% 0% 0% round 18px)', ease: 'power2.out',
        scrollTrigger: { trigger: '#kit', start: 'top 85%', end: 'center 55%', scrub: 1 } });
  });

  /* ---------------- RESEARCH: stat count + meter ---------------- */
  ScrollTrigger.create({
    trigger: '#research', start: 'top 60%', once: true, onEnter: () => {
      const o = { v: 0 };
      gsap.to(o, { v: 78.6, duration: 2.2, ease: T.ease.out, onUpdate: () => $('#statVal').textContent = o.v.toFixed(1) });
      gsap.to('#meter', { scaleX: 1, duration: 2.2, ease: T.ease.out });
    }
  });

  /* ---------------- MARQUEE: velocity-reactive ---------------- */
  const marq = $('#marq');
  let mx = 0, vel = 0;
  lenis.on('scroll', e => { vel = e.velocity || 0; });
  gsap.ticker.add(() => {
    const half = marq.scrollWidth / 2;
    mx -= .6; /* jon-1103: constant speed, not tied to the scroll wheel */
    if (-mx >= half) mx += half;
    marq.style.transform = `translate3d(${mx}px,0,0)`;
  });

  /* ---------------- BUY ---------------- */
  ScrollTrigger.create({ trigger: '.guarantee', start: 'top 85%', once: true, onEnter: () => gsap.to('#gRing', { strokeDashoffset: 0, duration: 2, ease: T.ease.inout }) });

  /* ---------------- magnetic CTAs (pointer: fine only) ---------------- */
  if (matchMedia('(pointer:fine)').matches) {
    $$('.btn').forEach(b => {
      const qx = gsap.quickTo(b, 'x', { duration: .5, ease: 'power3.out' }), qy = gsap.quickTo(b, 'y', { duration: .5, ease: 'power3.out' });
      b.addEventListener('mousemove', e => { const r = b.getBoundingClientRect(); qx((e.clientX - r.left - r.width / 2) * .18); qy((e.clientY - r.top - r.height / 2) * .28); });
      b.addEventListener('mouseleave', () => { qx(0); qy(0); });
    });
  }

  addEventListener('load', () => ScrollTrigger.refresh());

  /* ===================== Editorial additions ===================== */
  {
  // before/after sliders
  document.querySelectorAll('[data-ba]').forEach(function(f){
    var r=f.querySelector('.ba__range');
    function set(v){f.style.setProperty('--p',v+'%');}
    r.addEventListener('input',function(){set(r.value);});
    // gentle reveal sweep the first time it enters view
    var done=false;
    var io=new IntersectionObserver(function(es){es.forEach(function(e){
      if(e.isIntersecting&&!done){done=true;io.disconnect();
        if(document.documentElement.classList.contains('rm'))return;
        var t0=null,from=92,to=50;set(from);
        function step(ts){if(!t0)t0=ts;var k=Math.min(1,(ts-t0)/1800);var ease=1-Math.pow(1-k,4);var v=from+(to-from)*ease;set(v);r.value=v;if(k<1)requestAnimationFrame(step);}
        setTimeout(function(){requestAnimationFrame(step);},350);
      }});},{threshold:.45});
    io.observe(f);
  });
  // drag-to-scroll gallery rail
  var rail=document.getElementById('galRail');
  if(rail){window.zbDrag(rail);}
  // parallax on the peace photo + rail drift (gsap if present)
  if(typeof gsap!=='undefined'&&typeof ScrollTrigger!=='undefined'&&!RM){
    /* jon-1103: removed scroll drift on the gallery rail (fought with dragging) */
  }
  }

  // ---- Editorial banner: crossfade carousel, whoop-style progress, swipe, pause on hover/offscreen
  (function(){
    var eb=document.getElementById('peace'); if(!eb||!eb.classList.contains('eb'))return;
    var all=[].slice.call(eb.querySelectorAll('.eb__s')), barsEl=document.getElementById('ebBars');
    var NAMES=['Morning ritual','The Atelier Edit','Quiet luxury','Fifteen minutes, daily','Garden hour'];
    var DUR=6500, slides=[], cur=0, t0=0, elapsed=0, paused=false, inView=true, raf=0, bars=[];
    function visible(){return all.filter(function(s){return getComputedStyle(s).display!=='none';});}
    function build(){
      slides=visible(); barsEl.innerHTML=''; bars=slides.map(function(s,i){
        var b=document.createElement('button'); b.className='eb__bar'; b.setAttribute('role','tab');
        b.setAttribute('aria-label','Show slide '+(i+1)); b.innerHTML='<i></i><span>'+NAMES[+s.dataset.i]+'</span>';
        b.addEventListener('click',function(){go(i);}); barsEl.appendChild(b); return b;});
      slides.forEach(function(s,i){var e=s.querySelector('.eb__e'); if(e) e.innerHTML=String(i+1).padStart(2,'0')+' &nbsp;/&nbsp; '+NAMES[+s.dataset.i];});
      cur=Math.min(cur,slides.length-1); show(cur);
    }
    function show(i){
      all.forEach(function(s){s.classList.remove('is-on');s.setAttribute('aria-hidden','true');});
      slides[i].classList.add('is-on'); slides[i].removeAttribute('aria-hidden');
      slides[i].querySelectorAll('img').forEach(function(im){im.loading='eager';});
      var nx=slides[(i+1)%slides.length]; nx.querySelectorAll('img').forEach(function(im){im.loading='eager';});
      bars.forEach(function(b,k){b.classList.toggle('is-on',k===i);b.classList.toggle('is-done',k<i);b.firstChild.style.width=k<i?'100%':'0';b.setAttribute('aria-selected',k===i);});
    }
    function go(i){cur=(i+slides.length)%slides.length; elapsed=0; t0=performance.now(); show(cur);}
    function tick(now){
      if(!paused&&inView&&!RM){elapsed+=now-t0;}
      t0=now; var p=Math.min(elapsed/DUR,1); if(bars[cur])bars[cur].firstChild.style.width=(p*100)+'%';
      if(p>=1)go(cur+1); raf=requestAnimationFrame(tick);
    }
    document.getElementById('ebPrev').addEventListener('click',function(){go(cur-1);});
    document.getElementById('ebNext').addEventListener('click',function(){go(cur+1);});
    eb.addEventListener('mouseenter',function(){paused=true;}); eb.addEventListener('mouseleave',function(){paused=false;});
    var sx=null,sy=0;
    eb.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;sy=e.touches[0].clientY;},{passive:true});
    eb.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx,dy=e.changedTouches[0].clientY-sy;
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))go(cur+(dx<0?1:-1)); sx=null;},{passive:true});
    document.addEventListener('keydown',function(e){var r=eb.getBoundingClientRect();if(r.top<innerHeight*.5&&r.bottom>innerHeight*.5){if(e.key==='ArrowRight')go(cur+1);if(e.key==='ArrowLeft')go(cur-1);}});
    if('IntersectionObserver' in window){new IntersectionObserver(function(en){inView=en[0].isIntersecting;},{threshold:.25}).observe(eb);}
    var mq=matchMedia('(max-width:860px)'); (mq.addEventListener?mq.addEventListener('change',build):mq.addListener(build));
    build(); t0=performance.now(); raf=requestAnimationFrame(tick);
  })();

  // ---- Film: video split across public viktor.page chunk pages (2MB page cap); chunks arrive via postMessage
  (function(){
    var fr=document.getElementById('filmFrame'); if(!fr)return;
    var vid=document.getElementById('filmVid'), snd=document.getElementById('filmSnd'), load=document.getElementById('filmLoad');
    var BASE='/', N=6, started=false, parts={}, got=0, prefix='';
    function start(){
      if(started)return; started=true;
      prefix=matchMedia('(max-width:860px)').matches?'zb-film-v':'zb-film-h';
      window.addEventListener('message',function(e){
        var m=e.data; if(!m||m.zbv!==prefix||parts[m.i])return;
        parts[m.i]=m.d; got++; load.querySelector('span').style.setProperty('--p',(got/m.n*100)+'%');
        if(got===m.n){
          var bufs=[]; for(var k=1;k<=m.n;k++){var s=atob(parts[k]),a=new Uint8Array(s.length);for(var q=0;q<s.length;q++)a[q]=s.charCodeAt(q);bufs.push(a);}
          vid.src=URL.createObjectURL(new Blob(bufs,{type:'video/mp4'}));
          vid.addEventListener('canplay',function(){fr.classList.add('is-ready');if(inView)vid.play().catch(function(){});},{once:true});
          vid.load();
          document.querySelectorAll('iframe[data-zbv]').forEach(function(f){f.remove();});
        }
      });
      for(var i=1;i<=N;i++){var f=document.createElement('iframe');f.src=BASE+prefix+'-'+i;f.setAttribute('data-zbv','1');f.setAttribute('aria-hidden','true');f.tabIndex=-1;
        f.style.cssText='position:absolute;width:1px;height:1px;left:-9999px;top:0;border:0;opacity:0';document.body.appendChild(f);}
    }
    var inView=false;
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(en){if(en[0].isIntersecting)start();},{rootMargin:'1200px 0px'}).observe(fr);
      new IntersectionObserver(function(en){inView=en[0].isIntersecting; if(!fr.classList.contains('is-ready'))return; inView?vid.play().catch(function(){}):vid.pause();},{threshold:.35}).observe(fr);
    } else start();
    snd.addEventListener('click',function(){vid.muted=!vid.muted; if(!vid.muted){vid.currentTime=vid.currentTime<1?0:vid.currentTime; vid.play();}
      snd.classList.toggle('is-on',!vid.muted); snd.querySelector('b').textContent=vid.muted?'Sound on':'Sound off'; snd.setAttribute('aria-label',vid.muted?'Turn sound on':'Turn sound off');});
  })();
})();
